import React, { forwardRef, useState, useEffect } from 'react'
import { useScrollIntoView } from '@mantine/hooks'
import Layouts from './layouts'
import NavMenu from './NavMenu'

const layoutsIndexInfo = (layoutInfo) => {
  let currentIndex = -1
  return layoutInfo.map((item) => {
    const { content = {} } = item
    const { children = [] } = content
    currentIndex++
    const obj = { ...content, index: currentIndex }
    const arr = children.map((v) => {
      currentIndex++
      return { ...v, index: currentIndex }
    })
    return { ...item, content: { ...obj, children: arr } }
  })
}

const GroupLayout = function (
  {
    formControl,
    data = {},
    layout = [],
    fields,
    editableFields,
    isShowNavMenu,
    widgets,
    detailData,
    waterMarkDefs,
    isHiddenMedia,
    refConditonFields,
    children,
  },
  ref
) {
  const { scrollIntoView, scrollableRef, targetRef } = useScrollIntoView()
  const [activeNavIndex, setActiveNavIndex] = useState()

  useEffect(() => {
    setActiveNavIndex(0)
  }, [data && data.objectId])

  useEffect(() => {
    if (scrollIntoView) {
      scrollIntoView()
    }
  }, [activeNavIndex])

  return (
    <div
      className="overflow-y-scroll w-full flex-1 h-full gap-6 py-6"
      ref={scrollableRef}
      style={{ paddingLeft: '1.875rem', paddingRight: '1.875rem' }}
    >
      {isShowNavMenu && (
        <NavMenu
          navs={layout || []}
          data={data}
          activeNavIndex={activeNavIndex}
          onChange={(index) => {
            setActiveNavIndex(index)
          }}
          editableFields={editableFields}
        />
      )}
      {layoutsIndexInfo(layout).map((lay, index) => {
        return (
          <Layouts
            key={`layouts-${index}`}
            data={data}
            formControl={formControl}
            content={lay.content}
            fields={fields}
            editableFields={editableFields}
            activeNavIndex={activeNavIndex}
            useScrollIntoView={{ scrollIntoView, targetRef }}
            widgets={widgets}
            waterMarkDefs={waterMarkDefs}
            ref={ref}
            detailData={detailData}
            isHiddenMedia={isHiddenMedia}
            refConditonFields={refConditonFields}
          />
        )
      })}
      {children}
    </div>
  )
}

export default forwardRef(GroupLayout)
